import script from "./DmReceivedPaymentDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./DmReceivedPaymentDetail.vue?vue&type=script&setup=true&lang=js"

import "./DmReceivedPaymentDetail.vue?vue&type=style&index=0&id=530b65e6&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_influencer_admin_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-530b65e6"]])

export default __exports__